var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5589_4663",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 6,
    width: 32,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1254 6.90039H15.9587C10.1451 6.90039 7.23751 6.90039 5.43222 8.75606C4.13105 10.0908 3.76722 12.013 3.66547 15.2129H34.4186C34.3169 12.013 33.9531 10.0908 32.6519 8.75606C30.8466 6.90039 27.939 6.90039 22.1254 6.90039ZM15.9587 32.2337H22.1254C27.939 32.2337 30.8466 32.2337 32.6519 30.3781C34.4572 28.5224 34.4587 25.5378 34.4587 19.5671C34.4587 18.8683 34.4577 18.2086 34.4556 17.5879H3.62847C3.62539 18.2086 3.62436 18.8683 3.62539 19.5671C3.62539 25.5378 3.62539 28.524 5.43222 30.3781C7.23905 32.2321 10.1451 32.2337 15.9587 32.2337Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63672 25.8984C8.63672 25.5835 8.75854 25.2814 8.97538 25.0587C9.19222 24.836 9.48631 24.7109 9.79297 24.7109H15.9596C16.2663 24.7109 16.5604 24.836 16.7772 25.0587C16.9941 25.2814 17.1159 25.5835 17.1159 25.8984C17.1159 26.2134 16.9941 26.5154 16.7772 26.7381C16.5604 26.9608 16.2663 27.0859 15.9596 27.0859H9.79297C9.48631 27.0859 9.19222 26.9608 8.97538 26.7381C8.75854 26.5154 8.63672 26.2134 8.63672 25.8984ZM18.6576 25.8984C18.6576 25.5835 18.7794 25.2814 18.9962 25.0587C19.213 24.836 19.5071 24.7109 19.8138 24.7109H22.1263C22.433 24.7109 22.7271 24.836 22.9439 25.0587C23.1607 25.2814 23.2826 25.5835 23.2826 25.8984C23.2826 26.2134 23.1607 26.5154 22.9439 26.7381C22.7271 26.9608 22.433 27.0859 22.1263 27.0859H19.8138C19.5071 27.0859 19.213 26.9608 18.9962 26.7381C18.7794 26.5154 18.6576 26.2134 18.6576 25.8984Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5589_4663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.539062 0.568359H37.5391V38.5684H0.539062V0.568359Z",
    fill: "black",
    fillOpacity: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCard);
export default __webpack_public_path__ + "static/media/payment_card.2cdd5c8856cad3a1999b06f52d590576.svg";
export { ForwardRef as ReactComponent };